<div class = "banner-container" *ngIf="images.length > 0">
    <div class = "carousel" #carousel>
        <ng-container *ngFor="let image of images; let i = index">
            <div class = "banner-image-container"
                 [style.background-image]="'url(' + image.path + ')'"
                 [ngClass] = "{'includes-url': image.url}"
                 (click)="image.url ? getUrl(image.url) : null">
            </div>
        </ng-container>
    </div>
    <div class = "banner-controls">
        <ng-container *ngFor="let image of images; let i = index">
            <div class = "banner-control" [ngClass]="{'active': carouselPosition == i}" (click) = "scrollToIndex(i)"></div>
        </ng-container>
    </div>    
</div>
